import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function trimTo2Decimals(num: number) {
  return Math.floor(num * 100) / 100;
}

export function trimTo1Decimal(num: number) {
  return (Math.floor(num * 100) / 100).toFixed(1);
}

export function formatNumber(number: number | string) {
  return new Intl.NumberFormat('en-US').format(Number(number));
}

export function formatDate(dateString: string) {
  if (!dateString) return '';
  return dayjs(dateString).format('M/D/YYYY');
}

export function formatDateTime(dateString: string) {
  if (!dateString) return '';
  return dayjs.utc(dateString).local().format('M/D/YYYY h:mm A');
}

export function getErrorDetail(error: unknown, fallback: string): string {
  return (error as { response?: { data?: { detail?: string } } })?.response?.data?.detail || fallback;
}
